import API from '@/models/API';

export default class Debts {
  constructor(item = {}) {}

  static get = (query, filters) =>
    API.get(
      `/companies/${localStorage.getItem('storeId')}/store-debts/monthly-analysis${query}${filters}`
    );

  static getMonthlyPoints = (query, filters) =>
    API.get(
      `/companies/${localStorage.getItem('storeId')}/store-debts/monthly-points${query}${filters}`
    );

  static getRedemptionInvoice = (query, filters) =>
    API.get(
      `/companies/${localStorage.getItem('storeId')}/store-debts/monthly-analysis-redemption${query}${filters}`
    );

  static getSmsMetrics = (date) =>
    API.get(`/companies/${localStorage.getItem('storeId')}/sms-metrics?date=${date}`);

  static getViberMetrics = (date) =>
    API.get(`/companies/${localStorage.getItem('storeId')}/viber-metrics?date=${date}`);
}
